import { IRequestorLA } from 'onboarding/classes/models/requestorLA'
import { TRequestorToFillLAT1Form } from 'onboarding/components/widgets/public/forms/requestorFillLAT1/models'

export const mapToForm = ({
  AdditionalComments,
  BuyerType,
  Exhibits,
  HPContractAdminLocation,
  PartnerTerritoryISO,
  SpecialPrograms,
}: IRequestorLA): TRequestorToFillLAT1Form => ({
  AdditionalComments,
  BuyerType,
  Exhibits,
  HPContractAdminLocation,
  PartnerTerritoryISO: PartnerTerritoryISO ? PartnerTerritoryISO.split(',') : [],
  SpecialPrograms: SpecialPrograms ? SpecialPrograms.split(',') : [],
})
